import {Comparator} from "../../../../types/GenericTypes";
import {
    orderByCurrentStel,
    orderByCurrentStelDec,
    orderByInitialMargin,
    orderByInitialMarginDec,
    orderByMargin,
    orderByMarginDec,
    orderRowsByName
} from "../../util/DashboardModelUtil";
import {RiskRow} from "../risk-model/RiskSummary";

export interface RiskSortOptions {
    readonly brokerRiskComparator: Comparator<RiskRow>;
    readonly branchRiskComparator: Comparator<RiskRow>;
    readonly adviserRiskComparator: Comparator<RiskRow>;
    readonly clientRiskComparator: Comparator<RiskRow>;
}

export function defaultSortOptions(): RiskSortOptions {
    return {
        brokerRiskComparator: orderRowsByName(),
        branchRiskComparator: orderByMargin(),
        adviserRiskComparator: orderByMargin(),
        clientRiskComparator: orderByMargin()
    };
}

export function stelAscending(): RiskSortOptions {
    return {
        brokerRiskComparator: orderByCurrentStel(),
        branchRiskComparator: orderByCurrentStel(),
        adviserRiskComparator: orderByCurrentStel(),
        clientRiskComparator: orderByCurrentStel()
    };
}

export function stelDescending(): RiskSortOptions {
    return {
        brokerRiskComparator: orderByCurrentStelDec,
        branchRiskComparator: orderByCurrentStelDec,
        adviserRiskComparator: orderByCurrentStelDec,
        clientRiskComparator: orderByCurrentStelDec
    };
}

export function initialMarginAscending(): RiskSortOptions {
    return {
        brokerRiskComparator: orderByInitialMargin(),
        branchRiskComparator: orderByInitialMargin(),
        adviserRiskComparator: orderByInitialMargin(),
        clientRiskComparator: orderByInitialMargin()
    };
}

export function initialMarginDescending(): RiskSortOptions {
    return {
        brokerRiskComparator: orderByInitialMarginDec,
        branchRiskComparator: orderByInitialMarginDec,
        adviserRiskComparator: orderByInitialMarginDec,
        clientRiskComparator: orderByInitialMarginDec
    };
}

export function marginAscending(): RiskSortOptions {
    return {
        brokerRiskComparator: orderByMargin(),
        branchRiskComparator: orderByMargin(),
        adviserRiskComparator: orderByMargin(),
        clientRiskComparator: orderByMargin()
    };
}

export function marginDescending(): RiskSortOptions {
    return {
        brokerRiskComparator: orderByMarginDec,
        branchRiskComparator: orderByMarginDec,
        adviserRiskComparator: orderByMarginDec,
        clientRiskComparator: orderByMarginDec
    };
}
